var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('span',{staticClass:"subtitle-1",domProps:{"textContent":_vm._s('Capítulos')}}),_c('div',{staticClass:"wrapper-select"},[_c('v-select',{staticClass:"mt-2",attrs:{"items":_setup.itemsSelect,"dense":"","outlined":"","hide-details":""},on:{"change":_setup.store.consultaListadeCapitulos},model:{value:(_setup.selected),callback:function ($$v) {_setup.selected=$$v},expression:"selected"}})],1)]),(_setup.items && _setup.items.length)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{attrs:{"items":_setup.items,"headers":[
        { text: 'Título', value: 'deTituloSubtitulo' },
        { text: 'Autores', value: 'autores' },
        { text: 'Paginação', value: 'dePaginacao', width: '150px' },
      ]},scopedSlots:_vm._u([{key:`item.dePaginacao`,fn:function({ item }){return [_c('a',{on:{"click":function($event){return _vm.$router.push({
              path:
                `/obras/visualiza/` +
                item.cdObra +
                `/` +
                _setup.TipoObra.CAPITULO_LIVRO,
              query: { back: 'true' },
            })}}},[_vm._v(" "+_vm._s(item.dePaginacao)+" ")])]}}],null,true)})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }